document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis()

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  // Expose Lenis globally for debugging (optional)
  window.lenis = lenis

  // GSAP + ScrollTrigger Integration
  gsap.registerPlugin(ScrollTrigger)

  ScrollTrigger.scrollerProxy(document.body, {
    scrollTop(value) {
      return arguments.length ? lenis.scrollTo(value) : lenis.scroll
    },
    getBoundingClientRect() {
      return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }
    }
  })

  // Sync Lenis with GSAP ScrollTrigger
  lenis.on("scroll", ScrollTrigger.update)

  if (Shopify && Shopify.designMode) {
    console.log("Running inside Shopify Theme Editor")
  }

  function initAnimations() {
    // Clear previous ScrollTriggers to avoid duplication
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());



    

    
// 🌟 Continuous Floating & Rotating Effect on Scroll
gsap.utils.toArray(".hero-motion-image-box").forEach((box) => {
  gsap.to(box, {
    x: gsap.utils.random(-150, 150), // Random left/right movement
    y: gsap.utils.random(-250, 250), // Random upward movement
    rotate: gsap.utils.random(-60, 60), // Continuous rotation while scrolling
    opacity: 1,
    duration: gsap.utils.random(3, 5), // Smooth transition timing
    ease: "power1.inOut",
    scrollTrigger: {
      trigger: box,
      start: "top 90%",
      end: "bottom top",
      scrub: 2, // Smooth motion as user scrolls
    }
  });
});


// 🚀 Randomized Fade-Out Effects When Image Box Reaches the Top
gsap.utils.toArray(".hero-motion-image").forEach((image) => {
  gsap.to(image, {
    opacity: gsap.utils.random(0, 0.4),  // Some disappear completely, some fade slightly
    scale: gsap.utils.random(0.6, 0.9),  // Random shrink effect
    rotation: gsap.utils.random(-15, 15), // Random rotation in both directions
    filter: "blur(" + gsap.utils.random(0, 5) + "px)", // Some get a blur effect
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: image.closest(".hero-motion-image-box"), // Targeting parent box
      start: "top 4%",  // When it reaches the top
      end: "bottom top",
      scrub: true
    }
  });
});




// horizontal scroll section
document.querySelectorAll(".scroll-container-flexi").forEach((container) => {
  const panels = gsap.utils.toArray(container.querySelectorAll(".horizontal-scroll-panel-wrapper"));

  if (window.innerWidth > 850) {
    // Desktop Horizontal Scroll Animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: () => `+=${window.innerHeight * panels.length}`,
        pin: true,
        scrub: 1,
      },
    });

    // Ensure all panels inside this container are stacked properly
    gsap.set(panels, {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
    });

    // Loop through each panel inside this specific container
    panels.forEach((panel, index) => {
      let fromVars = {};
      let toVars = { x: "0%", y: "0%" };

      // Set different slide directions
      switch (index) {
        case 0:
          fromVars = { y: "-10%" };
          break; // First panel - from top
        case 1:
          fromVars = { x: "-100%" };
          break; // Second panel - from left
        case 2:
          fromVars = { x: "100%" };
          break; // Third panel - from right
        case 3:
          fromVars = { y: "100%" };
          break; // Fourth panel - from bottom
      }

      // Add animation to timeline for this container
      tl.fromTo(panel, fromVars, toVars, "+=0.1");
    });
  } else {
    // Mobile Vertical Scroll with Parallax Effect
    gsap.utils.toArray(".horizontal-scroll-panel-wrapper").forEach((panel) => {
      gsap.fromTo(
        panel,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: panel,
            start: "top 80%",
            end: "top 20%",
            scrub: 1,
          },
        }
      );
    });
  }
});




// Grid Box Animation
gsap.utils.toArray(".grid-box-item").forEach((item) => {
  gsap.fromTo(
    item,
    { opacity: 0, y: 80 }, // Initial state
    {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: item,
        start: "top 85%",
        end: "top 60%",  // Control fade-in duration
        scrub: 0.5,  // Smooth transition on scroll
        toggleActions: "play none none none", // Prevent abrupt reset
      },
    }
  );
});

 

// Featured Collection
gsap.utils.toArray(".product-card-wrapper, .child-of-left-side-icons, .child-of-right-side-icons, .main-image-center, .featured-points-txt-wrapper, .image-with-text__media-item, .image-with-text__content").forEach((item) => {
  gsap.fromTo(
    item,
    { opacity: 0, y: 80 }, // Initial state
    {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: item,
        start: "top 85%",
        end: "top 60%",  // Control fade-in duration
        scrub: 0.5,  // Smooth transition on scroll
        toggleActions: "play none none none", // Prevent abrupt reset
      },
    }
  );
});


    

    
// Select all headings, paragraphs, and buttons
const headings = document.querySelectorAll(".hero-motion-heading");
const paragraphs = document.querySelectorAll(".hero-motion-paragraph");
const buttons = document.querySelectorAll(".hero-motion-button");

// Ensure all elements are hidden before the animation starts
gsap.set(headings, { opacity: 0, y: 50 });
gsap.set(paragraphs, { opacity: 0, y: 50 });
gsap.set(buttons, { opacity: 0, y: 50 });

// Animate headings first, followed by paragraphs, then buttons
headings.forEach((heading, index) => {
  gsap.to(heading, {
    opacity: 1,
    y: 0,
    duration: 1.7,
    ease: "power3.out",
    onComplete: () => {
      // Animate the corresponding paragraph right after the heading
      gsap.to(paragraphs[index], {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        onComplete: () => {
          // Animate the corresponding button right after the paragraph
          gsap.to(buttons[index], {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: "power3.out",
          });
        }
      });
    }
  });
});


    
    
    

    // Refresh ScrollTrigger after updating animations
    ScrollTrigger.refresh();
  }

  // Run animations on page load
  initAnimations();

  // 🔥 Listen for Shopify section updates (Fixes disappearing sections)
  document.addEventListener("shopify:section:load", (event) => {
    console.log("Section reloaded:", event.target);
    initAnimations(); // Re-run animations when a section is updated
  });

});
